import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup, Select } from '_atoms';
import { Typography } from '_atoms/Typography';
import { BUTTON_TEXT } from 'constants/text';
import type { Uuid } from 'store/reducers/types';
import type { JobWorkflowStep } from 'store/reducers/jobReducer';
import './style.scss';

interface PopupAssignToStepUserData {
  first_name_latin?: string;
  last_name_latin?: string;
  first_name_local?: string;
  last_name_local?: string;
  speciality?: string;
}

interface PopupAssignToStepProps {
  open: boolean;
  onClose: () => void;
  save: (step: Uuid | undefined) => void;
  userData: PopupAssignToStepUserData;
  stepsOptions: Array<JobWorkflowStep & { name?: string }>;
}

export const PopupAssignToStep: React.FC<PopupAssignToStepProps> = ({
  open,
  onClose,
  save,
  userData,
  stepsOptions,
}) => {
  const { t } = useTranslation();
  const [step, setStep] = useState<Uuid | undefined>(undefined);
  const steps = useMemo(() => stepsOptions.map(el => ({ ...el, value: el.uuid, label: el.name })), [stepsOptions]);
  useEffect(() => setStep(undefined), [open]);

  return (
    <Popup
      open={open}
      title={t('translation:popup_assign_to_step.title')}
      cancelButtonProps={{ onClick: onClose, children: BUTTON_TEXT.CANCEL }}
      okButtonProps={{ onClick: () => save(step), children: BUTTON_TEXT.CONFIRM, disabled: !step }}
    >
      <p className="assign-to-step__warning">
        <strong>{t('translation:popup_assign_to_step.warning_bold')}</strong>
        {t('translation:popup_assign_to_step.warning_text')}
      </p>
      <div className="user-info">
        <Typography.Text className="user-info__title">
          {userData.first_name_latin} {userData.last_name_latin}
        </Typography.Text>
        <Typography.Caption className="user-info__subtitle">
          {userData.first_name_local} {userData.last_name_local}
        </Typography.Caption>
        <Typography.Caption className="user-info__subtitle">{userData.speciality}</Typography.Caption>
      </div>
      <Select
        label={t('translation:popup_assign_to_step.label_step')}
        placeholder={t('translation:popup_assign_to_step.placeholder_select_step')}
        options={steps}
        onChange={setStep}
      />
    </Popup>
  );
};
